<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>商城宝箱配置</span>
        </div>

        <el-row :gutter="10" class="mb8" style="margin-top: 10px;">
          <el-col :span="1.5">
            <el-upload
              ref="box"
              class="upload-demo"
              :action="sys_app_logoAction"
              accept="xlsx"
              :limit="1"
              :on-success="(res)=>{return importUploadSuccess(res, 'box')}"
              :headers="headers"
            >
              <el-button v-permisaction="['config:shopBoxConfig:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
            </el-upload>
          </el-col>
          <el-col :span="1.5">
            <el-button
              v-permisaction="['config:shopBoxConfig:export']"
              type="primary"
              icon="el-icon-download"
              size="mini"
              @click="exportData('box')"
            >导出</el-button>
          </el-col>
        </el-row>
        <el-table
          :data="formData"
          border
          style="width: 70%"
        >
          <el-table-column
            prop="levelId"
            label="等级"
          >
            <template v-slot:default="scope">
              {{ scope.row.levelId }}
            </template>
          </el-table-column>
          <el-table-column
            prop="woodenChest"
            label="木宝箱"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.woodenChest" placeholder="木宝箱" />
            </template>
          </el-table-column>
          <el-table-column
            prop="goldenChest"
            label="银宝箱"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.goldenChest" placeholder="银宝箱" />
            </template>
          </el-table-column>
          <el-table-column
            prop="magicalChest"
            label="黄金宝箱"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.magicalChest" placeholder="黄金宝箱" />
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables()"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  exportGoodsSkuCfg,
  getBoxCoinList,
  importGoodsSkuCfg
} from '@/api/config/goods-sku-cfg'
export default {
  name: 'ShopBoxConfig',
  data() {
    return {
      loading: false,
      activeName: 'first',
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getBoxCoinList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData(name) {
      exportGoodsSkuCfg({ name: name }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response, name) {
      this.loading = true
      this.$refs[name].clearFiles()
      importGoodsSkuCfg({ data: response.data.path, name: name }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.loading = false
          this.msgSuccess(res.msg)
          this.getTables(name)
        } else {
          this.loading = false
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
